module.exports = __webpack_public_path__ + "static/media/pagamento_recorrente.fabeee32.png";